interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const generateSchema = (): Record<string, unknown> => {
    const base: Record<string, unknown> = {
      '@context': 'https://schema.org',
      '@type': type,
    };

    switch (type) {
      case 'Organization':
        return { ...base, ...data };
      case 'WebSite':
        return { ...base, ...data };
      case 'WebPage':
        return { ...base, ...data };
      case 'BreadcrumbList':
        return { ...base, ...data };
      case 'Article':
        return { ...base, ...data };
      case 'FAQPage':
        return { ...base, ...data };
      default:
        return { ...base, ...data };
    }
  };

  const schema = generateSchema();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}